var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostedVideeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.073 19.25H3.927a2.68 2.68 0 0 1-2.677-2.677V7.427A2.68 2.68 0 0 1 3.927 4.75h10.146a2.68 2.68 0 0 1 2.677 2.677v9.146a2.68 2.68 0 0 1-2.677 2.677Zm-10.146-13A1.179 1.179 0 0 0 2.75 7.427v9.146a1.179 1.179 0 0 0 1.177 1.177h10.146a1.179 1.179 0 0 0 1.177-1.177V7.427a1.179 1.179 0 0 0-1.177-1.177Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17.012a1.743 1.743 0 0 1-.882-.242l-4.496-2.622a.75.75 0 0 1-.372-.648v-3a.75.75 0 0 1 .372-.648l4.496-2.623a1.75 1.75 0 0 1 2.632 1.512v6.518A1.756 1.756 0 0 1 21 17.012Zm-4.25-3.943 4.124 2.406a.25.25 0 0 0 .376-.216V8.74a.25.25 0 0 0-.376-.216L16.75 10.93ZM11 12.75H7a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 0 1.5Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14.75a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-.75.75Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostedVideeo);
export default __webpack_public_path__ + "static/media/posted-videeo.77ce8a96039b40f12abd2977940d16e6.svg";
export { ForwardRef as ReactComponent };